import React from 'react';
import { Tray } from '../../elements';
import { SurveyEditWorkflowAssignment } from './SurveyEditWorkflowAssignment';
import { SurveyEditWorkflowChecklist } from './SurveyEditWorkflowChecklist';
import { SurveyEditWorkflowComments } from './SurveyEditWorkflowComments';
import { SurveyEditWorkflowEmployees } from './SurveyEditWorkflowEmployees';
import { SurveyEditWorkflowSettings } from './SurveyEditWorkflowSettings';

export function SurveyEditWorkflow(props: { surveyId: string }) {
    const { surveyId } = props;
    return (
        <Tray>
            <SurveyEditWorkflowAssignment surveyId={surveyId} />
            <SurveyEditWorkflowSettings surveyId={surveyId} />
            <SurveyEditWorkflowEmployees surveyId={surveyId} />
            <SurveyEditWorkflowChecklist surveyId={surveyId} />
            <SurveyEditWorkflowComments surveyId={surveyId} />
        </Tray>
    );
}
